import React from 'react';

import s from './LanguageControl.scss';
import { Link } from 'components/link/Link';
import { useIntl } from 'react-intl';

export const LanguageControl = () => {
  const { locale } = useIntl();

  const isEnglish = locale.toLowerCase() === 'en-us';
  const isIcelandic = locale.toLowerCase() === 'is';

  return (
    <ul className={s.languageControl}>
      <li className={s('languageControl__item', { active: isEnglish })}>
        {!isEnglish && <Link to="/en" transition={false}>English</Link>}
        {isEnglish && <>English</>}
      </li>
      <li className={s('languageControl__item', { active: isIcelandic })}>
        {!isIcelandic && <Link to="/" transition={false}>Íslenska</Link>}
        {isIcelandic && <>Íslenska</>}
      </li>
    </ul>
  );
};
